import { AjaxService } from 'NewAngular/services/core/ajax.service';
import { UrlsService } from 'NewAngular/services/core/urls.service';
import * as i0 from "@angular/core";
import * as i1 from "NewAngular/services/core/ajax.service";
import * as i2 from "NewAngular/services/core/urls.service";
export class BroadridgeIntegrationService {
    constructor(ajaxService, urlsService) {
        this.ajaxService = ajaxService;
        this.urlsService = urlsService;
    }
    activateBroadridgeIntegration(public_key, private_key) {
        // pragma: allowlist secret
        const url = this.urlsService.INTEGRATIONS.BROADRIDGE_INTEGRATION_OAUTH;
        const postParams = {
            public_key,
            private_key,
        };
        return this.ajaxService.postJsonDataObserveResponse(url, postParams);
    }
    getBroadridgeIntegrationStatus() {
        const url = this.urlsService.INTEGRATIONS.BROADRIDGE_INTEGRATION_STATUS;
        return this.ajaxService.getDataObserveBody(url);
    }
    deactivateBroadridgeIntegration() {
        const url = this.urlsService.INTEGRATIONS.BROADRIDGE_INTEGRATION_OAUTH;
        return this.ajaxService.deleteDataObserveResponse(url);
    }
    getBroadridgeAccountSearchResults(searchType, searchTerms, page) {
        const url = `${this.urlsService.getUrl(this.urlsService.INTEGRATIONS.BROADRIDGE_SEARCH, {
            searchType,
        })}?searchTerms=${searchTerms}&page=${page}`;
        return this.ajaxService.getDataObserveBody(url);
    }
    getBroadridgeGroupSearchResults(searchType, searchTerms, page) {
        const url = `${this.urlsService.getUrl(this.urlsService.INTEGRATIONS.BROADRIDGE_SEARCH, {
            searchType,
        })}?searchTerms=${searchTerms}&page=${page}`;
        return this.ajaxService.getDataObserveBody(url);
    }
    getBroadridgeGroupAccountResults(groupID, page) {
        const url = `${this.urlsService.getUrl(this.urlsService.INTEGRATIONS.BROADRIDGE_GROUP_ACCOUNTS, {
            groupID,
        })}?page=${page}`;
        return this.ajaxService.getDataObserveBody(url);
    }
    importBroadridgeAccountHoldings(postParams) {
        const url = this.urlsService.INTEGRATIONS.BROADRIDGE_IMPORT_ACCOUNT_HOLDINGS;
        return this.ajaxService.postJsonDataObserveBody(url, postParams);
    }
}
BroadridgeIntegrationService.ɵfac = function BroadridgeIntegrationService_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || BroadridgeIntegrationService)(i0.ɵɵinject(i1.AjaxService), i0.ɵɵinject(i2.UrlsService)); };
BroadridgeIntegrationService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: BroadridgeIntegrationService, factory: BroadridgeIntegrationService.ɵfac, providedIn: 'root' });
